import { PageTable, Header } from "/src/layouts/page";
import WithheldDestinationsTable from "./WithheldDestinationsTable/WithheldDestinationsTable";
import storage from "/src/utils/storage";
import "../WithheldDestinations.css";

function WithheldDestinationsPage() {
    const company = storage("session").get("company");

    return (
        <PageTable>
            <Header
                title={
                    <span>
                        Withheld destinations of <span style={{ color: "var(--main)" }}>{company ? company.name : ""}</span>
                    </span>
                }
            ></Header>
            <div className="withheld-destinations-page">
                <WithheldDestinationsTable />
            </div>
        </PageTable>
    );
}

export default WithheldDestinationsPage;
